import { fontDict } from "../fontDict";
import { CreateObjectArgs } from "../core";
import { UnresolvedObj } from "../types";

type NewIconArgs = CreateObjectArgs & {
  name: string;
};

export const createIcon = ({ name, ...restArgs }: NewIconArgs): UnresolvedObj => {
  const sprite = fontDict[name];
  if (!sprite) throw new Error(`Icon ${name} not found in fontDict`);

  return {
    ...restArgs,
    z: 0, // TODO create parent/inheritance function to set defaults
    w: sprite.w,
    h: sprite.h,
    sprite,
  };
}